import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Select, Space } from 'antd';
import { getCropNamesApi } from '../../api/crops';
import { CROP_NAME_IMAGE } from '../../utils/constants';

// Crop library entries repeat once per language; keep one per common_id.
function uniqueByCommonId(list) {
  const seen = new Set();
  return list.filter((c) => {
    if (c.common_id == null || seen.has(c.common_id)) return false;
    seen.add(c.common_id);
    return true;
  });
}

// Searchable crop picker whose value is the crop's common_id.
// onChange(commonId, crop) — crop is the crop_names row (name, image, common_id).
export default function CropCommonIdSelect({ value, onChange, style }) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const searchTimer = useRef(null);

  const load = useCallback(async (text = '') => {
    setLoading(true);
    try {
      const res = await getCropNamesApi({ lang: 'en', crop: text });
      const raw = Array.isArray(res.data) ? res.data : (res.data?.data || []);
      setOptions(uniqueByCommonId(raw));
    } catch {
      setOptions([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const onSearch = (text) => {
    clearTimeout(searchTimer.current);
    searchTimer.current = setTimeout(() => load(text), 300);
  };

  return (
    <Select
      showSearch
      value={value}
      onChange={(v) => onChange(v, options.find((c) => c.common_id === v) || null)}
      onSearch={onSearch}
      filterOption={false}
      loading={loading}
      placeholder="Select crop"
      style={{ width: 240, ...style }}
      options={options.map((c) => ({
        value: c.common_id,
        label: (
          <Space size={8}>
            {c.image && (
              <img src={CROP_NAME_IMAGE(c.image)} alt="" style={{ width: 20, height: 20, borderRadius: 3, objectFit: 'cover' }} />
            )}
            {c.name}
          </Space>
        ),
      }))}
    />
  );
}
